import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import logoimg from "../../assets/images/logo/logo.png"
import img1 from "../../assets/images/tiny-footer/01.png"
import img2 from "../../assets/images/tiny-footer/02.png"
import img3 from "../../assets/images/tiny-footer/03.png"
import img4 from "../../assets/images/tiny-footer/04.png"
import img5 from "../../assets/images/tiny-footer/05.png"
import Footr4 from '../../assets/images/tiny-footer/04.png'

const Slide = {
    slidesToShow: 5,
    Infinity: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 1000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Footer = () => {
    return (
        <div>
            <footer>
                <div id="footer" className="footer-main-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-4">
                                <div className="footer-block">
                                    <div className="footer-logo">
                                        <Link to="/" title="">
                                            <img
                                                src={logoimg}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                    </div>
                                    <ul className="footer-dtls">
                                        <li>555 A, East Manster Street, Ready Halley Neon, Uk 4512</li>
                                        <li>
                                            <Link to="tel:+4733378901" title="">
                                                +00 123 45678 44
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="mailto:Supportinfo@gmail.com" title="">
                                                Supportinfo@gmail.com
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="footer--social-icons">
                                        <li>
                                            <Link to="https://www.facebook.com/" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://x.com/" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.linkedin.com" title="" >
                                                <i className="flaticon-linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.pinterest.com/" title="">
                                                <i className="flaticon-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-8">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h4 className="footer-widget-heading">Quick Links</h4>
                                            <ul className="footer-menu">
                                                <li>
                                                    <Link to="/" title="">
                                                        Home page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Aboutus" title="">
                                                        About page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Shop" title="">
                                                        Shop Page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/BlogDetails" title="">
                                                        Blog Details
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Contactus" title="">
                                                        Contacts us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Shop-filter" title="">
                                                        Products
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h4 className="footer-widget-heading">Our Policy</h4>
                                            <ul className="footer-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        Privacy Protection
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Safe Payments
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Terms of Service
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Privacy Policy
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Shipping &amp; Returns
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-widget">
                                            <h4 className="footer-widget-heading">Profile</h4>
                                            <ul className="footer-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        My Account
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Checkout
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Order Tracking
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Help &amp; Support
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiny-footer-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="footer-coyright">
                                    Copyright © 2025. All Rights Reserved.
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 text-center">
                                <div className="tiny-footer-payment-img">
                                    <Slider className="slider tiny-payment-autoplay" {...Slide}>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="#" title="">
                                                <img
                                                    src={img3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="#" title="">
                                                <img
                                                    src={img3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footr4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={img5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <ul className="tiny-footer-menu">
                                    <li>
                                        <Link to="#" title="">
                                            Terms &amp; Conditions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    )
}

export default Footer